import type { HarmonyPackageDocument } from '@rhythmic/db/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { eq, useLiveQuery } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'
import { getHarmonyDocumentCollection } from '../contexts'

const logger = useRhythmicLogger('useDocumentById')
export function useDocumentById(packageId: string, documentId: string): UseLiveQueryReturn<HarmonyPackageDocument> {
  logger.debug('useDocumentById', { packageId, documentId })
  const collection = getHarmonyDocumentCollection(packageId)
  logger.debug('Using collection for document', { collection })
  const query = useLiveQuery((builder) => builder.from({ doc: collection }).where(({ doc }) => eq(doc.id, documentId)))
  logger.debug('Created live query for document', { query })
  return query
}
